import { useCallback, useEffect, useMemo, useState } from 'react';
import { lookupMonthName } from './global'
import { Link, useParams } from "react-router";
import API from './API';
import { AdminProjectMonthReport, QueryActivities, QueryOrders } from '../../backend/src/api/dto';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

function ProjectMonthReport() {
    const params = useParams();


    const [loading, setLoading] = useState(false)
    const [currentData, setCurrentData] = useState<AdminProjectMonthReport>({
        project: {
            name: ''
        },
        daysInMonth: 0,
        month: 0,
        year: 0,
        days: [],
        orders: [],
        loggedHours: [],
        persons: []
    })


    useEffect(() => {
        setLoading(true)
        Promise.all([
            API.getProjectMonthReport(params.year ?? '', params.month ?? '', params.projectId ?? ''),
            //API.getPerson(params.personId ?? '')
        ]).then((data) => {
            setCurrentData(data[0])
            //setPerson(data[1].person)
            setLoading(false)
        })
    }, [])

    const setPMApproval = (timeReportRowId: number, pmApproved: boolean) => {
        return API.setProjectMonthReport(timeReportRowId, { pmApproved }).then(() => {
            setCurrentData(prevData => {

                return {...prevData, orders: prevData.orders.map(order => {
                    if (order.timeReportRowId === timeReportRowId) {
                        console.log(order.pmApproved)
                        order.pmApproved = !order.pmApproved
                    }
                    return order
                })}
            })
        })
    }



    const lookupPerson = useCallback((personId: number) => {
        const found = currentData.persons.find(item => item.personId === personId)
        return found ? found.name + ' ' + found.surname : 'N/A'
    }, [currentData])

    const getActivities = useCallback((item: QueryOrders) => {
        const loggedActivities = currentData?.loggedHours?.reduce((acc, entry) => {

            if (item.timeReportRowId === entry.timeReportRowId) {
                const found = currentData?.activities?.find((act) => act.activityId === entry.activityId);
                if (found) {
                    if (acc.findIndex(it => it.activityId === entry.activityId) === -1) {
                        acc.push(found)
                    }
                }
            }
            return acc

        }, [] as QueryActivities[])

        return loggedActivities?.length ? loggedActivities : [{ activityId: 0, name: '' }]
    }, [currentData])

    const getLoggedHour = useCallback((timeReportRowId: number, day: number, withActivities: boolean = false, activity?: any) => {
        if (!currentData || !currentData.loggedHours) {
            return {
                hours: null,
                activityId: activity.activityId
            }
        }
        const foundItem = currentData.loggedHours.find(item => {
            if (withActivities) {
                return item.day === day && item.timeReportRowId === timeReportRowId && item.activityId === activity.activityId
            } else {
                return item.day === day && item.timeReportRowId === timeReportRowId
            }
        })
        if (foundItem) {
            return {
                hours: foundItem.hours,
                activityId: foundItem.activityId
            }
        }
        return {
            hours: null,
            activityId: activity.activityId
        }
    }, [currentData])

    const getRowLoggedHours = useCallback((timeReportRowId: number, activityId: number) => {
        return (currentData.loggedHours ?? []).reduce((acc, item) => {
            if (item.timeReportRowId === timeReportRowId && item.activityId === activityId) {
                acc += item.hours
            }
            return acc
        }, 0)
    }, [currentData])




    if (loading) {
        return (
            <div className="p-3">
                <div className="card">
                    <div className="card-header" style={{ height: '55px' }}>

                        <div className="row">
                            <div className="col-1">
                                <span className=""><Link to="/dashboard/reporting" className="btn btn-primary">Späť</Link></span>
                            </div>
                            <div className="col-6 mt-2  ">
                                <span className="me-5">Rok: ...</span>
                                <span className="me-5">Mesiac: ...</span>
                                <span className=" ">Projekt: ...</span>
                            </div>
                            <div className="col-1 mt-2"></div>
                            <div className="col-4 text-end"></div>
                        </div>


                    </div>
                    <div className="card-body">Nahrávam</div>


                </div>
            </div>
        )
    }



    return (
        <div className="p-3">
            <div className="card">
                <div className="card-header" style={{ height: '55px' }}>

                    <div className="row">
                        <div className="col-1">
                            <span className=""><Link to="/dashboard/reporting/2025/projects" className="btn btn-primary">Späť</Link></span>
                        </div>
                        <div className="col-6 mt-2  ">
                            <span className="me-5">Rok: <strong>{params.year}</strong></span>
                            <span className="me-5">Mesiac: <strong>{params.month}. <small>({lookupMonthName(params.month)})</small></strong></span>
                            <span className=" ">Projekt: <strong>{currentData.project.name}</strong></span>
                        </div>
                    </div>
                </div>
                <div className="card-body">
                    {
                        currentData.days ?

                            <table className="table table-bordered table-condensed table-hover">
                                <thead>
                                    <tr>
                                        <th style={{ fontSize: '12px' }}>Osoba</th>
                                        <th style={{ fontSize: '12px' }}>Komponent</th>
                                        <th style={{ fontSize: '12px' }} className="border-right">Aktivita</th>
                                        {
                                            currentData.days.map((day, index) => {
                                                let classes = ['text-center'];


                                                if (day.dayType === 1 || day.dayType === 2) {
                                                    classes.push('text-danger bg-light-pink');
                                                }


                                                return (
                                                    <th role="button" className={classes.join(' ')} style={{ fontSize: '12px', width: '25px' }}>{index + 1}</th>
                                                )
                                            })
                                        }
                                        <th className="text-center" style={{ fontSize: '12px', width: '40px', maxWidth: '40px' }}>Sumár</th>
                                        <th className="text-center" style={{ fontSize: '12px', width: '20px', maxWidth: '20px' }}>Info</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        currentData.orders.map(order => {
                                            const activities = getActivities(order)
                                            return (
                                                <>
                                                    {
                                                        activities.map((activity: any, index: number) => {
                                                            const rowLoggedHours = getRowLoggedHours(order.timeReportRowId, activity.activityId)
                                                            return (
                                                                <tr>
                                                                    {
                                                                        index === 0 ?
                                                                            <>
                                                                                <td style={{ fontSize: '12px', width: '60px' }} rowSpan={activities.length}>{lookupPerson(order.personId)}</td>
                                                                                <td style={{ fontSize: '12px', width: '60px' }} rowSpan={activities.length}>{order.name}</td>
                                                                            </>
                                                                            : null
                                                                    }
                                                                    <td style={{ fontSize: '12px', width: '60px' }} className="border-right">{activity.name}</td>
                                                                    {
                                                                        currentData.days?.map((day, index) => {
                                                                            const hours = getLoggedHour(order.timeReportRowId, day.day, order.withActivities, activity) ?? null;
                                                                            let classes = ['text-center reporting-entry'];





                                                                            if (!order.nonWorkingDayEntries && day.dayType !== 0) {
                                                                                return (
                                                                                    <td className="bg-light-pink"></td>
                                                                                )
                                                                            } else {
                                                                                return (
                                                                                    <td role="button" className={classes.join(' ')} style={{ fontSize: '12px', }}

                                                                                    >{hours.hours}</td>
                                                                                )
                                                                            }

                                                                        })
                                                                    }

                                                                    <td className="text-center" style={{ fontSize: '12px', width: '40px', maxWidth: '40px' }}>
                                                                        {rowLoggedHours}
                                                                    </td>

                                                                    {
                                                                        index === 0 ?
                                                                            <td className="text-center" rowSpan={activities.length} onClick={
                                                                                () => setPMApproval(order.timeReportRowId, !order.pmApproved)
                                                                            }>
                                                                                {
                                                                                    order.pmApproved ?
                                                                                        <FontAwesomeIcon fixedWidth icon={["fas", "user-tie"]} className="text-success" title="Schálené projektovým manažérom" />
                                                                                        : <FontAwesomeIcon fixedWidth icon={["fas", "user-tie"]} className="text-danger" title="Ešte nebolo schálené projektovým manažérom" />

                                                                                }
                                                                            </td>
                                                                            : null
                                                                    }


                                                                </tr>
                                                            )
                                                        })
                                                    }
                                                </>
                                            )
                                        })
                                    }
                                </tbody>
                            </table>
                            : null
                    }
                </div>
            </div>
        </div>
    )
}

export default ProjectMonthReport